<template>
  <div>
    <div class="card z-depth-5 p-3">
      <h4 class="text-center font-weight-bold py-3">Send a Broadcast Message</h4>
      <div class="col-md-6 offset-md-3 border p-4">
        <form>
          <div class="form-group mb-4">
            <div>
              <label>Please Select Message Receiver Group</label>
              <select
                class="form-control"
                v-model="group"
                required
                @change="getReceipients()"
              >
              <option selected disabled>-- Select A Group --</option>
              <option
                v-for="group in totalGroups"
                :key="group.group"
                v-bind:value="group.group"
              >
              Group  {{ group.group }}
              </option>
              </select>
            </div>
          </div>
          <div class="form-group mb-4" v-if="group && group != ''">
            <div>
              <label
                >Select specific receipients if you do not wish to send this message to
                all receipients (optional)</label
              >
              <select class="form-control" v-model="receipients" multiple>
                <option
                  v-for="(receipent, index) in fetchedReceipients"
                  :key="index"
                  :value="receipent._id"
                >
                  {{receipent.first_name}}  {{receipent.last_name}}
                </option>
              </select>
            </div>
          </div>
          <div class="form-group mb-4">
            <div>
              <label>Enter Broadcast Message Below</label>
              <textarea class="form-control" v-model="message" required></textarea>
            </div>
          </div>
          <div class="form-group">
            <div>
              <button type="button" @click="sendMessage()" class="btn btn-info btn-block">
                Send Message
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "BroadcastAdmin",
  components: {},
  data() {
    return {
      fastTeacherToken: localStorage.getItem("fastTeacherToken"),
      fastTeacherId: localStorage.getItem("fastTeacherId"),
      group: "",
      message: "",
      totalGroups: [],
      receipients: [],
      fetchedReceipients: [],
    };
  },
  methods: {
    sendMessage() {
      if (this.group != "" && this.group != null) {

        let data = {
          message: this.message,
        };

        if (this.receipients.length > 0) {
          data.students = this.receipients;
        } else {
          data.students = this.fetchedReceipients;
        }

        const config = {
          headers: {
            Authorization: "Bearer " + this.fastTeacherToken,
            "Content-Type": "application/json",
          },
        };
        this.$toast.open({
          message: "Processing : Sending Message Please Wait...",
          type: "info",
        });
        axios
          .post(this.$apiURI + "/notify/" + 'students', data, config)

          .then((response) => {
            if (response.data.error) {
              this.$toast.open({
                message: "Error : " + response.data.message,
                type: "error",
              });
            } else {
              this.$toast.open({
                message: "Broadcast Message Sent Successfully",
                type: "success",
              });
            }
          })
          .catch((error) => {
            this.$toast.open({
              message: "Error : " + error.response.data.message,
              type: "error",
            });
          });
      } else {
        this.$toast.open({
          message: "Error : Please select a group",
          type: "error",
        });
      }
    },

    getReceipients() {
      this.group != "" &&
      this.group != null 
        ? this.getStudents()
        : alert("error geting receipients");
    },

    getStudents() {
      const config = {
        headers: {
          Authorization: "Bearer " + this.fastTeacherToken,
          "Content-Type": "application/json",
        },
      };

      let data = {
        type: 'group',
        value: this.group
      };

      axios.post(this.$apiURI + "/account/search-students", data, config)
          .then((response) => {
              if (response.data.error) {
                  this.$toast.open({
                      message: "Error : " + response.data.message,
                      type: 'error'
                  });
              } else {
                  
                  // eslint-disable-next-line no-console
                  // console.log(response.data.data.teachers)
                  this.fetchedReceipients = response.data.data.students;
              }

          }).catch((error) => {
              this.$toast.open({
                  message: "Error : " + error.response.data.message,
                  type: 'error'
              });
          })
    },
  },
  mounted() {
    const config = {
          headers: {
            Authorization: "Bearer " + this.fastTeacherToken,
            "Content-Type": "application/json",
          },
        };
    axios
      .get(this.$apiURI + "/groups", config)
      .then((response) => {
        if (response.data.error) {
          this.$toast.open({
            message: "Error : " + response.data.message,
            type: "error",
          });
        } else {
          let groups = response.data.data.groups;
          this.totalGroups = groups;
        }
      })
      .catch((error) => {
        this.$toast.open({
          message: "Error : " + error.response.data.message,
          type: "error",
        });
      });
  },
};
</script>
